export function redirect(name: string, params: Record<string, unknown> = {}, timeout: number | null = null) {
  if (!timeout) {
    return window.location.href = window.route(name, params);
  }

  setTimeout(() => window.location.href = window.route(name, params), timeout);
}

export function reload(timeout: number | null = null) {
  if (!timeout) {
    return window.location.reload();
  }

  setTimeout(() => window.location.reload(), timeout);
}

export const route = window.route;
